import Flickity from 'flickity';
const calpak = window.calpak


// TODO refactor and clean up
// Newer simpler product cards
calpak.variantUpdateProductCard = (target, isFlickity = false) => {
    const productContainer = target.closest(".product-card")

    // Handle flickity carousel swapping
    if (isFlickity) {
        const carouselElem = productContainer.querySelector('.js-flickity');
        if (!carouselElem) return;
        const color = target.getAttribute('data-value');
        // Find hidden template for this color
        const template = productContainer.querySelector(`template.variant-images-template[data-value="${color}"]`);
        if (!template) return;
        // Destroy existing Flickity instance if present
        if (Flickity.data) {
            const existing = Flickity.data(carouselElem);
            if (existing) existing.destroy();
        }
        // Replace slides
        carouselElem.innerHTML = template.innerHTML;
        // Re-initialize Flickity
        try {
            const options = JSON.parse(carouselElem.getAttribute('data-flickity'));
            new Flickity(carouselElem, options);
        } catch (err) {
            console.error('Error re-initializing Flickity:', err);
        }
    }
    // End of Flickity carousel swapping

    const productImageContainer = productContainer.querySelector(".product-unit__image")
    const productTitle = target.getAttribute("data-product-title");
    const imgUrl = target.getAttribute("data-image");
    const cprice = parseFloat(target.getAttribute("data-cprice"));
    const price =  parseFloat(target.getAttribute("data-price"));
    const color =  target.getAttribute("data-value");

    // set product-link link to selected swatch
    if (productContainer.querySelector('.product-unit__image.product-link')) {
        productContainer.querySelector('.product-unit__image.product-link').setAttribute("href", target.getAttribute("href"))
    }


    if (target.getAttribute("data-available") === "false") {
        productContainer.classList.add("product-unit--na");
        if (
            target.getAttribute(`data-soldout-all-variants`) === true ||
            target.getAttribute(`data-soldout-this-variant`) === true
        ) {
            // productContainer.classList.add("product-unit--so");
        } else {
            productContainer.classList.add("product-unit--jw");
        }
    } else {
        productContainer.classList.remove("product-unit--na");
        productContainer.classList.remove("product-unit--so");
        productContainer.classList.remove("product-unit--jw");
    }

    // TODO
    let formatedPrice = `<span class="sr-only">Current price: </span><b> ${formatPrice(price / 100)}</b>`;
    // if (option.closest(".pdp-gwp__inner")) {
    //     formatedPrice = `<span class="sr-only">Current price: </span><s>${formatPrice(price / 100)}</s>`;
    // }
    if (cprice)
        formatedPrice = `<span class="sr-only">Original price: </span><s>${formatPrice(cprice / 100).trim()}</s>` + formatedPrice;

    if (!cprice) {
        formatedPrice = `<span class="sr-only">Original price: </span><b>${formatPrice(price / 100)}</b>`;
    }

    productContainer.querySelectorAll(".product-unit__price")?.forEach((priceElement) => {
        priceElement.innerHTML = formatedPrice;
    });

    function formatPercent(x) {
        x = Math.floor(Number(x));// / 100;
        if (isNaN(x)) return x;
        return (x.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace('.00', '')) + '%';
    }

    if (cprice && cprice > price) {
        let saleMessage = `${formatPercent((cprice - price) * 100 / cprice)} OFF`;
        productContainer.querySelectorAll(".product-label.product-label--sale")?.forEach((saleElement) => {
            saleElement.classList.remove('product-label--hidden');
            saleElement.innerHTML = saleMessage;
        });
    }else{
        productContainer.querySelectorAll(".product-label.product-label--sale").forEach(element => {
            element.classList.add('product-label--hidden');
        });
    }

    
//   const flashSaleDiscountMessage = productContainer.querySelector(".flash-sale-discount-message");
//   if(flashSaleDiscountMessage){
//     const discountPrice = (Math.floor(price / 100 * flashSaleDiscountMessage.dataset.percent) / 100).toFixed(2);
//     const discountedPrice = formatPrice(price / 100 - Number.parseFloat(discountPrice));
//     const highlightDiscount = flashSaleDiscountMessage.dataset.highlightCode;
//     let discountCode = flashSaleDiscountMessage.dataset.code;
//     if(highlightDiscount == "true")
//       discountCode = `<span class="highlight">${discountCode}</span>`;
//     let message = "";
//     if(flashSaleDiscountMessage.dataset.code != "")
//       message = `${discountedPrice} with Code ${discountCode}`;
//     else
//     {
//         message = `${discountedPrice}`;
//     }
//     if(flashSaleDiscountMessage.querySelector("span.message"))
//       flashSaleDiscountMessage.querySelector("span.message").innerHTML = message
//   }


    //.product-unit-with-salelabel


    // productContainer.querySelectorAll(".product-unit__price")?.forEach((priceElement) => {
    //   priceElement.innerHTML = formatedPrice;
    // });

    // const pdpDscnts = productContainer.querySelectorAll(".dscnt");
    // if (cprice) {
    //   let discount = Math.floor(((cprice - price) * 100) / cprice);
    //   pdpDscnts.forEach((pdpDscnt) => {
    //     pdpDscnt.parentNode.classList.remove("product-label--hidden");
    //     if (pdpDscnt.dataset.priceDiscount == 'true') {
    //       const priceDiscount = Math.floor((cprice - price) / 100);
    //       pdpDscnt.innerHTML = `$${priceDiscount}`;
    //     } else {
    //       pdpDscnt.innerHTML = `${discount}%`;
    //     }
    //   });
    // } else
    //   pdpDscnts.forEach((pdpDscnt) =>
    //       pdpDscnt.parentNode.classList.add("product-label--hidden")
    //   );

    // const pdpMonochromeBadges = productContainer.querySelectorAll(".product-label--monochrome");
    // pdpMonochromeBadges.forEach((badge) => {
    //   if (badge.dataset.monochromeVariants.indexOf(option.dataset.option1) != -1) {
    //     badge.classList.remove("product-label--hidden");
    //     badge.classList.remove("product-label--na");
    //     badge.dataset.color = option.dataset.option1;
    //     return;
    //   } else {
    //     badge.classList.add("product-label--hidden");
    //     badge.classList.add("product-label--na");
    //   }
    // });

    if (productContainer.classList.contains("adding-to-cart"))
        productContainer.classList.remove("adding-to-cart");
    if (productContainer.classList.contains("added-to-cart"))
        productContainer.classList.remove("added-to-cart");

    let sizes = "50vw";
    let imageAlt = target.getAttribute("data-alt");
    if (imgUrl && !isFlickity) {
        productImageContainer.querySelector("picture source").setAttribute("srcset", calpak.lazyloadImageSrcset(imgUrl, [400], true));
        productImageContainer.querySelector("picture img").setAttribute("alt", `${imageAlt ? imageAlt : productTitle} view 1`);
        sizes = productImageContainer.querySelector("picture source").getAttribute("sizes");

        if (productImageContainer.classList.contains("stop-gif") && imgUrl.includes(".gif")) {
            let canvasElement = productImageContainer.querySelector("canvas");
            if (!canvasElement)
                canvasElement = document.createElement("canvas");
            canvasElement.style.width = "100%";
            canvasElement.style.height = "100%";
            productImageContainer.querySelector("picture").appendChild(canvasElement);
            const ctx = canvasElement.getContext('2d');
            const img = productImageContainer.querySelector("picture img");
            img.onload = function () {
                // Draw the first frame on the canvas
                setTimeout(() => {
                    ctx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
                    img.style.display = 'none';  // Hide the GIF
                }, 200);
            };
        }

        calpak.productUnitUpdateHover(target, productTitle, productImageContainer)
    }

    const optionalLabels = productContainer.querySelectorAll(
        ".product-label[data-options]"
    );

    optionalLabels.forEach((optionalLabel) => {
        if (optionalLabel.matches(`[data-options~="${color}"]`)) {
            optionalLabel.classList.add("product-label--active");
        } else {
            optionalLabel.classList.remove("product-label--active");
        }
    });

    if (document.body.classList.contains("california")) {
        const sku = target.getAttribute("data-sku");
        if (calpak.hideSkusCalifornia?.includes(sku?.toUpperCase())) {
            if (productContainer) {
                productContainer.classList.add("product-unit--na");
                productContainer.classList.add("product-unit--jw");
            }
        }
    }
}

const badgeTypes = [
    { type: "coming-soon", attribute: "data-coming-soon-tags", swatchBadgeClass: ".coming-soon-label-swatch", productBadgeClass: '.coming-soon-label' },
    { type: "new-arrivals", attribute: "data-new-arrivals-tags", swatchBadgeClass: ".new-arrivals-label-swatch", productBadgeClass: '.new-arrivals-label' },
    { type: "back-in-stock", attribute: "data-back-in-stock-tags", swatchBadgeClass: ".back-in-stock-label-swatch" , productBadgeClass: '.back-in-stock-label'}
]

calpak.productNewBadges = (swatch, parentElement) => {
    if (swatch) {
        const product = swatch.closest(parentElement);
        const selectedColorValue = swatch.getAttribute('data-value');
        const bestSellerBadge = product?.querySelector(".product-label.bestseller-label");
        const recycledBadge = product?.querySelector(".product-label.recycled-label");
        const condenastBadge = product?.querySelector(".product-label--conde-nast");

        let isnewLabelsActive = false
        const mainBadge = product?.querySelector(badgeTypes.find(({ productBadgeClass }) => product?.querySelector(productBadgeClass))?.productBadgeClass);

        if (swatch.hasAttribute("data-coming-soon-tags")) {
            const comingSoonTags = swatch.getAttribute("data-coming-soon-tags").split(';').flatMap(tag => tag.split(',').map(innerTag => innerTag.trim()));
            const isComingSoon = comingSoonTags.includes(selectedColorValue);

            const pdpGrid = document.querySelector(".pdp__grid--coming-soon");
            const comingSoonSubmitLabel = document.querySelector(".pdp__grid--coming-soon .pdp__floating-submit .pdp__submit-label .submit-label-coming-soon");
            const soldOutSubmitLabel = document.querySelector(".pdp__grid--coming-soon .pdp__floating-submit .pdp__submit-label .submit-label-sold-out");

            if (pdpGrid) pdpGrid.classList.remove("hide-pdp__grid--coming-soon");
            if (isComingSoon) {
                if(comingSoonSubmitLabel) comingSoonSubmitLabel.style.display = "flex";
                if(soldOutSubmitLabel) soldOutSubmitLabel.style.display = "none";
            } else {
                if(comingSoonSubmitLabel) comingSoonSubmitLabel.style.display = "none";
                if(soldOutSubmitLabel) soldOutSubmitLabel.style.display = "flex";
            }
        }

        badgeTypes.forEach(({ type, attribute, swatchBadgeClass }) => {
            const selectedTags = swatch.getAttribute(attribute);
            const badge = product?.querySelector(swatchBadgeClass);

            if (selectedTags) {
                const tags = selectedTags.split(';').flatMap(tag => tag.split(',').map(innerTag => innerTag.trim()));

                const isActive = tags.includes(selectedColorValue);

                if (badge) {
                    badge.style.setProperty(`--swatch-badge-display`, isActive ? "flex" : "none");
                    if (isActive) {
                        badge.classList.add(`hide-badge-${type}`)
                    } else {
                        badge.classList.remove(`hide-badge-${type}`)
                    }
                    if (mainBadge) mainBadge?.style.setProperty(`--product-badge-display`, isActive ? "none" : "flex");
                    if (isActive) {
                        isnewLabelsActive = true;
                    }
                }
            }
        });

        if (!isnewLabelsActive) {
            // if(bestSellerBadge) bestSellerBadge.classList.remove("hide-bestseller-label");
            // if(recycledBadge) recycledBadge.classList.remove("hide-recycled-label");
            // if(condenastBadge) condenastBadge.classList.remove("hide-conde-nast-label");
        } else {
            // if(bestSellerBadge) bestSellerBadge.classList.add("hide-bestseller-label");
            // if(recycledBadge) recycledBadge.classList.add("hide-recycled-label");
            // if(condenastBadge) condenastBadge.classList.add("hide-conde-nast-label");
        };
    }
}

calpak.selectThisColorSwatch = async (colorSwatch) => {
    if (colorSwatch == null || !colorSwatch.closest(".swatches-container"))
        return;
    const actives = colorSwatch
        .closest(".swatches-container")
        .querySelectorAll(".color-swatch--active");
    actives.forEach((active) => active.classList.remove("color-swatch--active"));
    colorSwatch.classList.add("color-swatch--active");

    calpak.productNewBadges(colorSwatch, ".product-card");
    calpak.variantUpdateProductCard(colorSwatch)
}

calpak.applyColorToProductCard = (productCards, color) => {
    if (!productCards?.length) return;

    const swatchSelector = `.product-unit__swatches .color-swatch[data-value='${color}']`;

    [...productCards].forEach(productCard => {
        if (!productCard) return;

        const colorSwatch = productCard.querySelector(swatchSelector);
        if (!colorSwatch) return;

        const productImageContainer = productCard.querySelector(".product-unit__image");
        if (!productImageContainer) return;

        const source = productImageContainer.querySelector("picture source");
        const img = productImageContainer.querySelector("picture img");
        if (!source || !img) return;

        const dataImage = colorSwatch.getAttribute("data-image");
        const dataAlt = colorSwatch.getAttribute("data-alt");
        const dataTitle = colorSwatch.getAttribute("data-product-title");

        requestAnimationFrame(() => {
            source.srcset = calpak.lazyloadImageSrcset(dataImage, [400], true);
            img.alt = `${dataAlt} view 1`;
            calpak.productUnitUpdateHover(colorSwatch, dataTitle, productImageContainer);
        });
    });
};

// ada product card swatches
function adaColorSwatches(target, colorSwatches, page = "") {
    const swatchesContainer = target?.querySelector('.product-unit__swatches');
    let isKeyboardNavigation = false;

    colorSwatches.forEach(function (colorButton, index) {

        colorButton.addEventListener('click', function (e) {
            e.preventDefault();
            isKeyboardNavigation = false;
        });

        colorButton.addEventListener('keydown', function (e) {
            if (e.key === "" || e.code === "Space" || e.keyCode === 32) {
                e.preventDefault();
                e.target.click();
            }
            const key = e.key;

            if (key === 'ArrowRight' || key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                isKeyboardNavigation = true;
                focusNextSwatch(page === "sidecart" ? index + 1 : index);
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                isKeyboardNavigation = true;
                focusPreviousSwatch(page === "sidecart" ? index - 1 : index);
            }
        });

        colorButton.addEventListener('focus', function (e) {
            selectAndScrollToSwatch(colorButton);
        });
    });

    function focusNextSwatch(index) {
        if (index <= colorSwatches.length - 1) {
            colorSwatches[index].focus();
            selectAndScrollToSwatch(colorSwatches[index]);
        } else {
            colorSwatches[0].focus();
            selectAndScrollToSwatch(colorSwatches[0]);
        }
    }

    function focusPreviousSwatch(index) {
        if (index >= 0) {
            colorSwatches[index].focus();
            selectAndScrollToSwatch(colorSwatches[index]);
        } else {
            colorSwatches[colorSwatches.length - 1].focus();
            selectAndScrollToSwatch(colorSwatches[colorSwatches.length - 1]);
        }
    }

    function selectAndScrollToSwatch(button) {
        colorSwatches.forEach(colorButton => {
            colorButton.setAttribute("tabindex", colorButton === button ? "0" : "-1");
        });

        if (isKeyboardNavigation) {
            const scrollAmount = button.offsetLeft - swatchesContainer.offsetLeft - (swatchesContainer.clientWidth / 2) + (button.clientWidth / 2);

            requestAnimationFrame(() => {
                swatchesContainer.scrollTo({
                    left: scrollAmount,
                    behavior: 'smooth'
                });
            });
        }
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.target.classList.contains("color-swatch--active") && entry.target.getAttribute("tabindex") != 0) {
                if (entry.isIntersecting) {
                    entry.target.removeAttribute('aria-hidden');
                    entry.target.removeAttribute('tabindex');
                } else {
                    entry.target.setAttribute('aria-hidden', 'true');
                    entry.target.setAttribute('tabindex', '-1');
                }
            }
        });
    }, { threshold: 0.1 });

    colorSwatches?.forEach(colorButton => {
        observer.observe(colorButton);
    });
}

calpak.adaColorSwatches = adaColorSwatches;

// handle size selector click
// TODO refactor and bring in rest from global.js for old product unit code
window.addEventListener("click", async (e) => {
    if (e.target.classList.contains("size-swatch")) {
        e.preventDefault();

        const optionSize = e.target.dataset.title;
        let activeSelected = false
        // TODO refactor a better way
        e.target.parentNode.parentNode.parentNode.parentNode.parentNode
            .querySelectorAll(".swatches-container .color-swatch").forEach((swatch) => {
            swatch.classList.remove("hide")
            swatch.classList.remove("color-swatch--active")
            if (swatch.dataset.option2 !== optionSize){
                swatch.classList.add("hide")
            }
            if (swatch.dataset.option2 === optionSize && !activeSelected){
                activeSelected = true
                swatch.classList.add("color-swatch--active")
                calpak.variantUpdateProductCard(swatch);
            }
        })

        //  mark 2
        // TODO remove what's not needed below
        if (!e.target.classList.contains("no-color")) {
            const thisSize = e.target.querySelectorAll("span")[0].innerHTML;
            const thisPrice = e.target.querySelectorAll("span")[1].innerHTML;
            const sizesContainer =
                e.target.parentNode.querySelectorAll(".size-swatch");
            // TODO omg refactor this

            const variantSelector =
                e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector(
                    ".variant-select"
                );
            // TODO omg refactor this
            const selectedContainer =
                e.target.parentNode.parentNode.parentNode.querySelector("label");
            const componentContainer =
                e.target.parentNode.parentNode.parentNode.querySelector(
                    'input[type="checkbox"]'
                );
            // TODO omg refactor this
            const colorContainer =
                e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector(
                    ".product-unit__colors"
                )
                    ? e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector(
                        ".product-unit__colors"
                    )
                    : null;
            const colorTarget = colorContainer
                ? colorContainer.querySelector(
                    ".product-unit__colors .color-swatch--active"
                )
                : null;

            componentContainer.checked = false;
            selectedContainer.innerHTML = `<span>${thisSize}</span> <span>${thisPrice}</span>`;
            sizesContainer.forEach((element) => element.classList.remove("selected"));
            e.target.classList.add("selected");
            // console.log('---------- calpak.variantUpdateProcess(colorTarget)')
            // console.log(e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode)
            // console.log(colorContainer)
            // console.log(colorTarget)
            // calpak.variantUpdateProductCard(colorTarget);
            calpak.variantUpdateProcess(colorTarget);

            colorContainer.querySelectorAll(".color-swatch").forEach((color) => {
                // console.log(color.dataset.value)
                // console.log(e.target.dataset.title)
                const variantSelector =
                    e.target.parentNode.closest(
                        ".product-unit__swatches"
                    )
                if (variantSelector) {
                    const option = variantSelector.querySelector(
                        `[data-option1="${color.dataset.value}"][data-option2="${e.target.dataset.title}"]`
                    );
                    option.dataset.available == "true"
                        ? color.classList.remove("product-option--na")
                        : color.classList.add("product-option--na");
                }

            });
        } else {
            const thisSize = e.target.querySelectorAll("span")[0].innerHTML;
            const thisPrice = e.target.querySelectorAll("span")[1].innerHTML;
            const sizesContainer =
                e.target.parentNode.querySelectorAll(".size-swatch");
            const selectedContainer =
                e.target.parentNode.parentNode.parentNode.querySelector("label");
            const componentContainer =
                e.target.parentNode.parentNode.parentNode.querySelector(
                    'input[type="checkbox"]'
                );
            e.target
                .closest(".product-unit")
                .querySelector(".product-unit__option")
                .setAttribute("value", e.target.getAttribute("data-value"));

            componentContainer.checked = false;
            selectedContainer.innerHTML = `<span>${thisSize}</span> <span>${thisPrice}</span>`;
            sizesContainer.forEach((element) => element.classList.remove("selected"));
            e.target.classList.add("selected");

            calpak.variantUpdateProcess(e.target);
        }
    }
});

document.addEventListener("calpak:loaded", function () {
    const productContainer = document.querySelectorAll(".product-card");
    if(productContainer?.length){
        productContainer?.forEach((product)=>{
            const colorSwatches = product?.querySelectorAll(".product-unit__swatches .color-swatch");
            if (colorSwatches.length > 0) {
                adaColorSwatches(product, colorSwatches);
            }
        });
    }

    // Old product unit cards activate sliders,  TODO remove when not needed
    document.querySelectorAll(".product-grid .product-unit.activate-js .product-unit__swatches")
        .forEach((swatches) => {
            swatches.classList.add("slider");
            const sliderWrapper = swatches.parentNode;
            sliderWrapper.setAttribute("data-slide", 4);
            sliderWrapper.setAttribute("data-slide-mob", 2);
            sliderWrapper.classList.add(
                "slider__wrapper",
                "slider__wrapper--start"
            );
        });

    // OMG this is so bad
    document.querySelectorAll(".product-grid .product-unit.activate-js .product-unit__colors").forEach(
        (colors) => {
            colors.classList.add("product-unit__colors--all", "slide");
            colors.parentNode.parentNode
                .querySelector(".product-unit__colors--quickadd")
                .append(colors);
        });

    // Activate sliders (activate nav/arrows) TODO refactor
    // console.log(sliderWrapper.querySelector(".slider"));
    document.querySelectorAll(".product-grid .product-unit.activate-js .product-unit__swatches .slider, .product-grid .product-card .product-unit__swatches")
        .forEach((swatches) => {
            setTimeout(function () {
                calpak.checkSlider(swatches);
            }, 10);
        });

    if (document.querySelector(".section-daily-deals")) {
        // !!!
        const productGrids = document.querySelectorAll(".section-daily-deals");
        //quick add function
        document
            .querySelectorAll(".section-daily-deals .quick-view__link")
            .forEach((link) => link.classList.add("hide"));
        document
            .querySelectorAll(".section-daily-deals")
            .forEach((grid) => grid.classList.add("product-grid--gap"));
        document
            .querySelectorAll(".section-daily-deals .product-unit")
            .forEach((productUnit) => {
                productUnit.classList.add("product-unit--quickadd");
            });
        document
            .querySelectorAll(".section-daily-deals .product-unit__colors")
            .forEach((colors) => {
                colors.classList.add("product-unit__colors--all", "slide");
                colors.parentNode.parentNode
                    .querySelector(".product-unit__colors--quickadd")
                    .append(colors);
            });
        let productUnits = [];
        productGrids.forEach(productGrid => {
            productUnits.push(...productGrid.querySelectorAll(".product-unit"));
        })

        productUnits.forEach((productUnit) => {
            const colors = productUnit.querySelector(".product-unit__colors");
            if (colors) {
                // Find the quickadd colors container
                const colorsQuickAdd = productUnit.querySelector(
                    ".product-unit__colors--quickadd"
                );
                if (colorsQuickAdd) {
                    if (!colorsQuickAdd.contains(colors)) {
                        colors.classList.add("product-unit__colors--all", "slide");
                        colorsQuickAdd.appendChild(colors);
                    }
                }
            }
        });

        document.querySelectorAll(".section-daily-deals .product-unit__button")
            .forEach((productUnitButton) =>
                productUnitButton.classList.add("product-unit__button--active")
            );

        document
            .querySelectorAll(".section-daily-deals .product-unit__swatches")
            .forEach((swatches) => {
                swatches.classList.add("slider");
                const sliderWrapper = swatches.parentNode;
                sliderWrapper.setAttribute("data-slide", 4);
                sliderWrapper.setAttribute("data-slide-mob", 2);
                sliderWrapper.innerHTML += `<button class="round-icon slider__control slider__control--prev round-icon--prev" title="Previous"></button><button class="round-icon slider__control slider__control--next round-icon--next" title="Next"></button>`;
                sliderWrapper.classList.add(
                    "slider__wrapper",
                    "slider__wrapper--start"
                );

                calpak.checkSlider(sliderWrapper.querySelector(".slider"));
            });

        if (document.querySelector(".section-daily-deals")) {
            // !!!
            const productGrids = document.querySelectorAll(".section-daily-deals");
            //quick add function
            const loadQuickAdd = () => {
                document
                    .querySelectorAll(".section-daily-deals .quick-view__link")
                    .forEach((link) => link.classList.add("hide"));
                document
                    .querySelectorAll(".section-daily-deals")
                    .forEach((grid) => grid.classList.add("product-grid--gap"));
                document
                    .querySelectorAll(".section-daily-deals .product-unit")
                    .forEach((productUnit) => {
                        productUnit.classList.add("product-unit--quickadd");
                    });
                document
                    .querySelectorAll(".section-daily-deals .product-unit__colors")
                    .forEach((colors) => {
                        colors.classList.add("product-unit__colors--all", "slide");
                        colors.parentNode.parentNode
                            .querySelector(".product-unit__colors--quickadd")
                            .append(colors);
                    });
            };
        }


        const subcategoryLinks = document.querySelectorAll("a.filter__collection");
        [].map.call(subcategoryLinks, (subcategoryLink) => {
            subcategoryLink.addEventListener("click", (e) => {
                setTimeout(function () {
                    loadQuickAdd();
                }, 300);
            });
        });
    }

    // Reorder color swatches of bundle items to prioritize matched combinations
    const bundleItems = document.querySelectorAll(".product-card:has(.color-swatch--bundled)");
    if(bundleItems?.length){
        bundleItems?.forEach((product)=>{
            const colorSwatches = product?.querySelectorAll(".product-unit__swatches .color-swatch");
            if (colorSwatches.length > 0) {
                let currentIndex = 0, prevColor = "";
                colorSwatches?.forEach((colorSwatch) => {
                    colorSwatch.classList.remove('color-swatch--first');

                    if (!colorSwatch.classList.contains('product-option--na')) {
                        const first_option = colorSwatch.getAttribute("data-option1");
                        const second_option = colorSwatch.getAttribute("data-option2");
    
                        if (prevColor && prevColor != first_option)
                            currentIndex += 1;
    
                        if (first_option && second_option) {
                            colorSwatch.style.order = currentIndex + (first_option != second_option);
                            if (colorSwatch.style.order == 0) {
                                colorSwatch.classList.add('color-swatch--first');
                                calpak.selectThisColorSwatch(colorSwatch);
                            }
                        }
    
                        prevColor = first_option;
                    }
                })
            }
        });
    }

    // Remove mismatched combinations for bundle items
    if(bundleItems?.length) {
        bundleItems.forEach((product) => {
            if(product.classList.contains('matched-only')) {
                const colorSwatches = product?.querySelectorAll(".product-unit__swatches .color-swatch");
                if (colorSwatches.length > 0) {
                    colorSwatches?.forEach((colorSwatch) => {
                        const first_option = colorSwatch.getAttribute("data-option1");
                        const second_option = colorSwatch.getAttribute("data-option2");
                        
                        if(first_option != second_option) {
                            colorSwatch.style.display = 'none';
                        } else {
                            colorSwatch.classList.add('color-swatch--matched');
                        }
                    })

                    const first_matched_swatch = product?.querySelectorAll(".product-unit__swatches .color-swatch--matched:not(.product-option--na)")?.[0];
                    
                    calpak.selectThisColorSwatch(first_matched_swatch);
                }
            }
        })
    }
})
